var LoadService = require('services/load-service');

var courseSettings;
var CourseSettingsService = function() {
  if (CourseSettingsService.prototype._singleton) {
    return CourseSettingsService.prototype._singleton;
  }

  CourseSettingsService.prototype._singleton = this;

  this.files = {
    courseSettings: './content/course-settings.json'
  };
  this.initialize = function(settings){
    return LoadService.load(this.files).done(function(data){
      var course = data.courseSettings;
      if (settings.env && course[settings.env]){
        course = _.extend(course, course[settings.env]);
      }
      course = _.extend(course, settings);
      courseSettings = new Chaplin.Model(course);
    });
  };

  this.get = function(key){
    return courseSettings.get(key);
  };

  this.getModel = function(){
    return courseSettings;
  };
};

module.exports = new CourseSettingsService();
